export const SCORES_EMPTY_STATE = {
  LOGO_SIZE: 90,
  CALENDAR_WIDTH: 44,
  CALENDAR_HEIGHT: 48,
}